import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";
import { objectToQuery } from "../../ObjectToQuery";

class GetTayehMarketplaceCategoriesResponse {
    name: string;
    id: string;
    instance_username: string;
}

class getTyMarketplaceProductsQuery {
    page? = 0;
    per_page? = 10;
    search?: string;
}

export function getTyMarketplaceShopCategories(instance_username: string, params?: getTyMarketplaceProductsQuery): Promise<AxiosResponse<GetTayehMarketplaceCategoriesResponse[]>> {    
    const query = `/marketplace/${instance_username}/categories?${objectToQuery(params)}`;
    return Cirus.get(query);
}